export default __webpack_public_path__ + "static/media/bibooHi.afff5444.png";